import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.VUE_APP_API_ALARM}ticker`,
  
  headers: {
    Accept: "*/*",
  },
});

// Function to get binanca coin list
const getBinanceList = async () => {
  try {
    const response = await API.get("list?exchange_id=1");
    return response.data;
  } catch (error) {
    console.error("Error get goya alarm coins:", error);
    throw error;
  }
};

// Function to get bybit coin list
const getBybitList = async () => {
  try {
    const response = await API.get("list?exchange_id=2");
    return response.data;
  } catch (error) {
    console.error("Error get goya alarm coins:", error);
    throw error;
  }
};

// Function to get okx coin list
const getOkxList = async () => {
  try {
    const response = await API.get("list?exchange_id=3");
    return response.data;
  } catch (error) {
    console.error("Error get goya alarm coins:", error);
    throw error;
  }
};

export default {
  getBinanceList,
  getBybitList,
  getOkxList,
};
